import { render } from "./RestartMembershipPage.vue?vue&type=template&id=aa99604e&scoped=true"
import script from "./RestartMembershipPage.vue?vue&type=script&lang=js"
export * from "./RestartMembershipPage.vue?vue&type=script&lang=js"

import "./RestartMembershipPage.vue?vue&type=style&index=0&id=aa99604e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa99604e"]])

export default __exports__